import React from 'react';

export default function CustomTableHeader({tableColumns}){
    return(
        <thead className="custom-table-header">
            <tr>  
            {tableColumns.map(({title},key) =>         
                <th key={`head_list_${key}`} scope="col">{title}</th>
            )}
            </tr>
        </thead>
    );
}
